"use client"

import axios from "axios"
import JoditEditor from "jodit-react"
import { FaPlus, FaSave, FaTimes, FaUpload, FaCalendarAlt, FaMoneyBillWave, FaPercent, FaTag, FaLock } from "react-icons/fa"
import "../styles/criarEvento.css"
import "../styles/boleto-parcelado.css"
import BoletoParceladoConfig from "../components/BoletoParceladoConfig"
import { useParams, useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"

const EditarEvento = () => {
  const navigate = useNavigate()
  const { id } = useParams()

  const [imagem, setImagem] = useState(null)
  const [imagemPreview, setImagemPreview] = useState(null)
  const [nome, setNome] = useState("")
  const [premiacao, setPremiacao] = useState("")
  const [descricao, setDescricao] = useState("")
  const [dataInicio, setDataInicio] = useState("")
  const [dataFim, setDataFim] = useState("")
  const [dataEvento, setDataEvento] = useState("")
  const [ordemEvento, setOrdemEvento] = useState("")
  const [categorias, setCategorias] = useState([])
  const [mostrarModal, setMostrarModal] = useState(false)
  const [emailDono, setEmailDono] = useState("")
  const [taxaDono, setTaxaDono] = useState("")
  const [status, setStatus] = useState("aberto")
  const [loading, setLoading] = useState(false)
  const [circuitos, setCircuitos] = useState([])
  const [circuitoId, setCircuitoId] = useState("")
  const [taxasObrigatorias, setTaxasObrigatorias] = useState([])
  const [boletoParcelado, setBoletoParcelado] = useState({
    ativo: false,
    parcelasDisponiveis: [],
  })

  const [novaCategoria, setNovaCategoria] = useState({
    nome: "",
    senhas: [],
    dias: [],
    requerFiliacao: false,
  })

  // ─── Handlers gerais ─────────────────────────────────────────────────────
  const handleImagemChange = (e) => {
    const file = e.target.files[0]
    setImagem(file)
    if (file) {
      const reader = new FileReader()
      reader.onloadend = () => setImagemPreview(reader.result)
      reader.readAsDataURL(file)
    }
  }

  const handleTaxaChange = (index, campo, valor) => {
    const novas = [...taxasObrigatorias]
    novas[index][campo] = valor
    setTaxasObrigatorias(novas)
  }
  const adicionarTaxa = () => setTaxasObrigatorias([...taxasObrigatorias, { nome: "", valor: "" }])
  const removerTaxa = (index) => {
    const novas = [...taxasObrigatorias]
    novas.splice(index, 1)
    setTaxasObrigatorias(novas)
  }

  const abrirModal = () => {
    setNovaCategoria({ nome: "", senhas: [], dias: [], requerFiliacao: false })
    setMostrarModal(true)
  }
  const fecharModal = () => setMostrarModal(false)

  // ─── Handlers do modal (nova categoria) ──────────────────────────────────
  const adicionarSenha = () => {
    setNovaCategoria({
      ...novaCategoria,
      senhas: [...novaCategoria.senhas, { numero: novaCategoria.senhas.length + 1, preco: "", precoNoDia: "", boiTv: "" }],
    })
  }

  const handleSenhaChange = (index, campo, valor) => {
    const novasSenhas = [...novaCategoria.senhas]
    novasSenhas[index][campo] = valor
    setNovaCategoria({ ...novaCategoria, senhas: novasSenhas })
  }

  const adicionarDia = () => {
    setNovaCategoria({
      ...novaCategoria,
      // ✅ boiTvValor: campo auxiliar de UI — convertido em boiTvPorDia ao salvar
      dias: [...novaCategoria.dias, { nome: "", senhaInicial: "", senhaFinal: "", boiTvValor: "" }],
    })
  }

  const handleDiaChange = (index, campo, valor) => {
    const novosDias = [...novaCategoria.dias]
    novosDias[index][campo] = valor
    setNovaCategoria({ ...novaCategoria, dias: novosDias })
  }

  const handleCategoriaChange = (campo, valor) => {
    setNovaCategoria({ ...novaCategoria, [campo]: valor })
  }

  const adicionarCategoria = () => {
    // ✅ Extrai boiTvPorDia dos dias antes de salvar
    const boiTvPorDia = novaCategoria.dias
      .filter(d => d.nome && d.boiTvValor !== "" && d.boiTvValor !== undefined)
      .map(d => ({ dia: d.nome, valor: Number(d.boiTvValor) }))

    const categoriaFinal = {
      ...novaCategoria,
      boiTvPorDia,
      dias: novaCategoria.dias.map(({ boiTvValor, ...diaLimpo }) => diaLimpo),
    }

    setCategorias([...categorias, categoriaFinal])
    setMostrarModal(false)
  }

  // ─── Handlers de categorias existentes (inline) ───────────────────────────
  const handleDiaCategoriaChange = (categoriaIndex, diaIndex, campo, valor) => {
    const novas = [...categorias]
    novas[categoriaIndex].dias[diaIndex][campo] = valor
    setCategorias(novas)
  }

  const handleSenhaCategoriaChange = (categoriaIndex, senhaIndex, campo, valor) => {
    const novas = [...categorias]
    novas[categoriaIndex].senhas[senhaIndex][campo] = valor
    setCategorias(novas)
  }

  const handleCategoriaFieldChange = (index, campo, valor) => {
    const novasCategorias = [...categorias]
    novasCategorias[index][campo] = valor
    setCategorias(novasCategorias)
  }

  // ✅ NOVO: Atualiza o Boi TV de um dia específico em uma categoria existente
  const handleBoiTvPorDiaChange = (categoriaIndex, diaNome, valor) => {
    const novas = [...categorias]
    const cat = novas[categoriaIndex]
    if (!cat.boiTvPorDia) cat.boiTvPorDia = []

    const existeIdx = cat.boiTvPorDia.findIndex(b => b.dia === diaNome)

    if (valor === "" || valor === undefined) {
      // Remove a regra se campo ficar vazio
      if (existeIdx >= 0) cat.boiTvPorDia.splice(existeIdx, 1)
    } else {
      if (existeIdx >= 0) {
        cat.boiTvPorDia[existeIdx].valor = Number(valor)
      } else {
        cat.boiTvPorDia.push({ dia: diaNome, valor: Number(valor) })
      }
    }
    setCategorias(novas)
  }

  // ✅ NOVO: Retorna o valor atual do boiTvPorDia de um dia numa categoria existente
  const getBoiTvPorDiaValor = (categoriaIndex, diaNome) => {
    const regra = categorias[categoriaIndex]?.boiTvPorDia?.find(b => b.dia === diaNome)
    return regra !== undefined ? regra.valor : ""
  }

  const removerCategoria = (index) => {
    const novasCategorias = [...categorias]
    novasCategorias.splice(index, 1)
    setCategorias(novasCategorias)
  }

  const removerDiaCategoria = (categoriaIndex, diaIndex) => {
    const novasCategorias = [...categorias]
    novasCategorias[categoriaIndex].dias.splice(diaIndex, 1)
    setCategorias(novasCategorias)
  }

  // ─── Carrega dados ────────────────────────────────────────────────────────
  useEffect(() => {
    const carregarEvento = async () => {
      try {
        const res = await axios.get(`https://api.ticketdovaqueiro.com/api/events/${id}`)
        const evento = res.data
        setNome(evento.nome)
        setDescricao(evento.descricao)
        setPremiacao(evento.premiacao || "")
        setDataInicio(evento.dataInicio?.substring(0, 16))
        setDataFim(evento.dataFim?.substring(0, 16))
        setDataEvento(evento.dataEvento?.substring(0, 10))
        setOrdemEvento(evento.ordem || "")
        setEmailDono(evento.dono?.email || "")
        setTaxaDono(evento.taxaDono || "")
        setStatus(evento.status || "aberto")
        setCircuitoId(evento.circuitoId || "")
        setCategorias(evento.categorias || [])
        setTaxasObrigatorias(evento.taxasObrigatorias || [])
        if (evento.boletoParcelado) {
          setBoletoParcelado({
            ativo: evento.boletoParcelado.ativo || false,
            parcelasDisponiveis: evento.boletoParcelado.parcelasDisponiveis || [],
          })
        }
        if (evento.imagem) setImagemPreview(`https://api.ticketdovaqueiro.com/uploads${evento.imagem}`)
      } catch (err) {
        console.error("Erro ao carregar evento:", err)
        alert("Erro ao carregar dados do evento.")
      }
    }
    carregarEvento()
  }, [id])

  useEffect(() => {
    const carregarCircuitos = async () => {
      try {
        const res = await axios.get("https://api.ticketdovaqueiro.com/api/circuitos")
        setCircuitos(res.data || [])
      } catch (err) {
        console.error("Erro ao carregar circuitos:", err)
      }
    }
    carregarCircuitos()
  }, [])

  // ─── Submit ───────────────────────────────────────────────────────────────
  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    const formData = new FormData()
    formData.append("nome", nome)
    formData.append("descricao", descricao)
    formData.append("premiacao", premiacao)
    formData.append("dataInicio", dataInicio)
    formData.append("dataFim", dataFim)
    formData.append("dataEvento", dataEvento)
    formData.append("ordem", ordemEvento)
    formData.append("emailDono", emailDono || "")
    formData.append("status", status)
    formData.append("categorias", JSON.stringify(categorias))
    formData.append("taxaDono", taxaDono || "")
    formData.append("circuitoId", circuitoId || "")
    formData.append("taxasObrigatorias", JSON.stringify(taxasObrigatorias))
    formData.append("boletoParcelado", JSON.stringify(boletoParcelado))
    if (imagem) formData.append("imagem", imagem)

    try {
      const response = await axios.put(`https://api.ticketdovaqueiro.com/api/events/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data",
        },
      })
      if (response.status === 200) {
        alert("Evento atualizado com sucesso!")
        navigate("/admin/eventos")
      }
    } catch (error) {
      console.error(error)
      alert("Erro ao atualizar evento. Verifique os dados e tente novamente.")
    } finally {
      setLoading(false)
    }
  }

  // ─── Render ───────────────────────────────────────────────────────────────
  return (
    <div className="criar-evento-container">
      <div className="criar-evento-container2">
        <h6>Editar Evento</h6>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label><FaUpload /> Imagem do Evento:</label>
            <input type="file" onChange={handleImagemChange} />
            {imagemPreview && (
              <div className="imagem-preview">
                <img src={imagemPreview || "/placeholder.svg"} alt="Preview" style={{ maxWidth: "100%", maxHeight: "200px", marginTop: "10px", borderRadius: "8px" }} />
              </div>
            )}
          </div>

          <div className="form-group">
            <label><FaTag /> Email do Dono:</label>
            <input type="email" value={emailDono} onChange={(e) => setEmailDono(e.target.value)} placeholder="email@exemplo.com" />
          </div>

          <div className="form-group">
            <label><FaTag /> Nome do Evento:</label>
            <input type="text" value={nome} onChange={(e) => setNome(e.target.value)} required placeholder="Ex: Vaquejada de São João" />
          </div>

          <div className="form-group">
            <label><FaMoneyBillWave /> Premiação Total:</label>
            <input type="text" value={premiacao} onChange={(e) => setPremiacao(e.target.value)} required placeholder="Ex: R$ 50.000,00" />
          </div>

          <div className="form-group">
            <label><FaMoneyBillWave /> Taxas Obrigatórias:</label>
            {taxasObrigatorias.map((taxa, index) => (
              <div key={index} style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
                <input type="text" placeholder="Nome da taxa (ex: Seguro)" value={taxa.nome} onChange={(e) => handleTaxaChange(index, "nome", e.target.value)} />
                <input type="number" placeholder="Valor em R$" value={taxa.valor} onChange={(e) => handleTaxaChange(index, "valor", e.target.value)} />
                <button type="button" onClick={() => removerTaxa(index)}>❌</button>
              </div>
            ))}
            <button type="button" onClick={adicionarTaxa}><FaPlus /> Adicionar Taxa</button>
          </div>

          <div className="form-group">
            <label><FaPercent /> Taxa do Dono (%):</label>
            <input type="number" value={taxaDono} onChange={(e) => setTaxaDono(e.target.value)} placeholder="Ex: 10" />
          </div>

          <div className="form-group">
            <label>Status do Evento:</label>
            <select value={status} onChange={(e) => setStatus(e.target.value)}>
              <option value="aberto">Aberto</option>
              <option value="em breve">Em Breve</option>
              <option value="encerrado">Encerrado</option>
            </select>
          </div>

          <div className="form-group">
            <label>Vincular a um Circuito (opcional):</label>
            <select value={circuitoId} onChange={(e) => setCircuitoId(e.target.value)}>
              <option value="">Nenhum (Evento normal)</option>
              {circuitos.map((c) => (
                <option key={c._id} value={c._id}>{c.nome}</option>
              ))}
            </select>
          </div>

          <div className="form-group form-full-width">
            <label>Descrição:</label>
            <textarea value={descricao} onChange={(e) => setDescricao(e.target.value)} required placeholder="Descreva os detalhes do evento..." />
          </div>

          <div className="form-group">
            <label><FaCalendarAlt /> Data e Hora de Início das Vendas:</label>
            <input type="datetime-local" value={dataInicio} onChange={(e) => setDataInicio(e.target.value)} required />
          </div>

          <div className="form-group">
            <label><FaCalendarAlt /> Data e Hora de Fim das Vendas:</label>
            <input type="datetime-local" value={dataFim} onChange={(e) => setDataFim(e.target.value)} required />
          </div>

          <div className="form-group">
            <label><FaCalendarAlt /> Data do Evento:</label>
            <input type="date" value={dataEvento} onChange={(e) => setDataEvento(e.target.value)} required />
          </div>

          <div className="form-group form-full-width">
            <label>Ordem do Evento:</label>
            <JoditEditor value={ordemEvento} onChange={(content) => setOrdemEvento(content)} />
          </div>

          {/* ── Boleto Parcelado ───────────────────────────────────────────── */}
          <div className="form-group form-full-width">
            <BoletoParceladoConfig
              config={boletoParcelado}
              onChange={(v) => setBoletoParcelado(v)}
            />
          </div>

          {/* ── Categorias existentes ─────────────────────────────────────── */}
          <div className="categorias-section">
            <h2>Categorias</h2>
            {categorias.map((categoria, index) => (
              <div key={index} className="categoria-card">
                <input
                  type="text"
                  value={categoria.nome}
                  onChange={(e) => handleCategoriaFieldChange(index, "nome", e.target.value)}
                  placeholder="Nome da Categoria"
                />

                {circuitoId && (
                  <label style={{ display: "flex", alignItems: "center", gap: "8px", background: "rgba(212, 175, 55, 0.1)", padding: "10px", borderRadius: "8px", border: "1px solid rgba(212, 175, 55, 0.3)", margin: "16px 0", cursor: "pointer" }}>
                    <input
                      type="checkbox"
                      checked={categoria.requerFiliacao || false}
                      onChange={(e) => handleCategoriaFieldChange(index, "requerFiliacao", e.target.checked)}
                      style={{ width: "20px", height: "20px" }}
                    />
                    <strong><FaLock color="var(--c-accent)" /> Exigir filiação no circuito para comprar esta categoria?</strong>
                  </label>
                )}

                <button type="button" onClick={() => removerCategoria(index)} className="btn-remover-categoria">
                  <FaTimes /> Remover Categoria
                </button>

                <h4>Senhas:</h4>
                <ul>
                  {categoria.senhas.map((senha, i) => (
                    <li key={i} style={{ display: "flex", gap: "10px", marginBottom: "5px", alignItems: "center", flexWrap: "wrap" }}>
                      <span>Senha {senha.numero}</span>
                      <input type="number" value={senha.preco} onChange={(e) => handleSenhaCategoriaChange(index, i, "preco", e.target.value)} placeholder="Preço" style={{ width: "80px" }} />
                      <input type="number" value={senha.precoNoDia || ""} onChange={(e) => handleSenhaCategoriaChange(index, i, "precoNoDia", e.target.value)} placeholder="Valor no dia (opcional)" style={{ width: "140px", borderColor: "#ff6b6b" }} title="Valor no dia — só visual, aparece riscado como promoção. Deixe vazio para não exibir." />
                      <input type="number" value={senha.boiTv} onChange={(e) => handleSenhaCategoriaChange(index, i, "boiTv", e.target.value)} placeholder="Boi TV padrão" style={{ width: "100px" }} />
                    </li>
                  ))}
                  <button
                    type="button"
                    onClick={() => {
                      const novasCategorias = [...categorias]
                      novasCategorias[index].senhas.push({ numero: categorias[index].senhas.length + 1, preco: "", precoNoDia: "", boiTv: "" })
                      setCategorias(novasCategorias)
                    }}
                    style={{ marginTop: "8px", background: "#0d6efd", color: "#fff", border: "none", padding: "6px 12px", borderRadius: "4px", cursor: "pointer" }}>
                    <FaPlus style={{ marginRight: 6 }} /> Adicionar Senha
                  </button>
                </ul>

                <label style={{ display: "block", marginBottom: "4px", fontWeight: 600 }}>
                  Limite Máximo de Senhas Vendidas:
                </label>
                <input
                  type="number"
                  placeholder="Ex: 30 (deixe vazio para ilimitado)"
                  value={categoria.limiteSenhasVendidas || ""}
                  onChange={(e) => handleCategoriaFieldChange(index, "limiteSenhasVendidas", e.target.value === "" ? "" : Number(e.target.value))}
                  style={{ marginBottom: "8px", width: "220px" }}
                />

                {/* ── Limite Compartilhado ── */}
                <label style={{ display: "block", marginBottom: "4px", fontWeight: 600 }}>
                  Compartilhar limite com outra categoria:
                </label>
                <select
                  value={categoria.limiteCompartilhadoCom || ""}
                  onChange={(e) => handleCategoriaFieldChange(index, "limiteCompartilhadoCom", e.target.value || null)}
                  style={{ marginBottom: "8px", width: "260px" }}
                >
                  <option value="">Nenhum (limite independente)</option>
                  {categorias
                    .filter((_, i) => i !== index)
                    .map((cat, i) => (
                      <option key={i} value={cat.nome}>{cat.nome}</option>
                    ))
                  }
                </select>
                {categoria.limiteCompartilhadoCom && (
                  <p style={{ fontSize: 12, color: "#ffcc00", marginBottom: "16px" }}>
                    ⚠️ Limite compartilhado com <strong>{categoria.limiteCompartilhadoCom}</strong>.
                    A soma das vendas de ambas não pode ultrapassar o limite da categoria primária.
                  </p>
                )}

                <h4>Dias da Categoria:</h4>
                <ul>
                  {categoria.dias.map((dia, i) => (
                    <li key={i} style={{ display: "flex", gap: "10px", marginBottom: "8px", alignItems: "center", flexWrap: "wrap", borderBottom: "1px solid rgba(255,255,255,0.08)", paddingBottom: "8px" }}>
                      <input type="text" value={dia.nome} onChange={(e) => handleDiaCategoriaChange(index, i, "nome", e.target.value)} placeholder="Nome do dia" style={{ width: "120px" }} />
                      <input type="number" value={dia.senhaInicial} onChange={(e) => handleDiaCategoriaChange(index, i, "senhaInicial", e.target.value)} placeholder="Senha inicial" style={{ width: "100px" }} />
                      <input type="number" value={dia.senhaFinal} onChange={(e) => handleDiaCategoriaChange(index, i, "senhaFinal", e.target.value)} placeholder="Senha final" style={{ width: "100px" }} />
                      <input type="text" value={dia.senhasExcluidas || ""} onChange={(e) => handleDiaCategoriaChange(index, i, "senhasExcluidas", e.target.value)} placeholder="Senhas excluídas (ex: 5,10)" style={{ width: "180px" }} />

                      {/* ✅ NOVO: Boi TV específico para este dia */}
                      <input
                        type="number"
                        value={getBoiTvPorDiaValor(index, dia.nome)}
                        onChange={(e) => handleBoiTvPorDiaChange(index, dia.nome, e.target.value)}
                        placeholder="Boi TV neste dia (0=Grátis)"
                        style={{ width: "180px", borderColor: "#ffcc00" }}
                        title="Boi TV neste dia — deixe em branco para usar o valor padrão da senha"
                      />

                      <button type="button" onClick={() => removerDiaCategoria(index, i)}>❌</button>
                    </li>
                  ))}
                </ul>

                <button
                  type="button"
                  onClick={() => {
                    const novasCategorias = [...categorias]
                    novasCategorias[index].dias.push({ nome: "", senhaInicial: "", senhaFinal: "", senhasExcluidas: "" })
                    setCategorias(novasCategorias)
                  }}
                  style={{ marginTop: "8px", background: "#198754", color: "#fff", border: "none", padding: "6px 12px", borderRadius: "4px", cursor: "pointer" }}>
                  <FaPlus style={{ marginRight: 6 }} /> Adicionar Dia
                </button>
              </div>
            ))}

            <button type="button" onClick={abrirModal} className="btn-adicionar-categoria">
              <FaPlus /> Adicionar Categoria
            </button>
          </div>

          <button type="submit" disabled={loading}>
            {loading ? "Atualizando evento..." : <><FaSave /> Salvar Atualizações</>}
          </button>
        </form>

        {/* ── MODAL ADICIONAR CATEGORIA ─────────────────────────────────── */}
        {mostrarModal && (
          <div className="modal">
            <div className="modal-content">
              <h2>Adicionar Categoria</h2>
              <input type="text" placeholder="Nome da Categoria" value={novaCategoria.nome} onChange={(e) => handleCategoriaChange("nome", e.target.value)} />

              {circuitoId && (
                <label style={{ display: "flex", alignItems: "center", gap: "8px", background: "rgba(212, 175, 55, 0.1)", padding: "10px", borderRadius: "8px", border: "1px solid rgba(212, 175, 55, 0.3)", marginBottom: "16px", cursor: "pointer" }}>
                  <input
                    type="checkbox"
                    checked={novaCategoria.requerFiliacao}
                    onChange={(e) => handleCategoriaChange("requerFiliacao", e.target.checked)}
                    style={{ width: "20px", height: "20px" }}
                  />
                  <strong><FaLock color="var(--c-accent)" /> Exigir filiação no circuito para esta categoria?</strong>
                </label>
              )}

              <h3>Senhas</h3>
              <button onClick={adicionarSenha} className="btn-adicionar"><FaPlus /> Adicionar Senha</button>
              {novaCategoria.senhas.map((senha, index) => (
                <div key={index} className="senha-container">
                  <label>Senha {index + 1} - Preço (antecipado):</label>
                  <input type="number" value={senha.preco} onChange={(e) => handleSenhaChange(index, "preco", e.target.value)} placeholder="Valor em R$" />
                  <label style={{ color: "#ff6b6b", marginTop: "8px", display: "block" }}>
                    🏷️ Valor no dia (opcional — só visual, aparece riscado como promoção):
                  </label>
                  <input type="number" value={senha.precoNoDia} onChange={(e) => handleSenhaChange(index, "precoNoDia", e.target.value)} placeholder="Deixe em branco para não exibir" style={{ borderColor: "#ff6b6b" }} />
                  <label>Boi TV (padrão):</label>
                  <input type="number" value={senha.boiTv} onChange={(e) => handleSenhaChange(index, "boiTv", e.target.value)} placeholder="Valor em R$" />
                </div>
              ))}

              <h3>Adicionar Dia</h3>
              <button onClick={adicionarDia} className="btn-adicionar"><FaPlus /> Adicionar Dia</button>
              {novaCategoria.dias.map((dia, index) => (
                <div key={index} className="dia-container">
                  <label>Nome do Dia:</label>
                  <input type="text" value={dia.nome} onChange={(e) => handleDiaChange(index, "nome", e.target.value)} placeholder="Ex: Sexta-feira" />
                  <label>Senha Inicial:</label>
                  <input type="number" value={dia.senhaInicial} onChange={(e) => handleDiaChange(index, "senhaInicial", e.target.value)} placeholder="Ex: 1" />
                  <label>Senha Final:</label>
                  <input type="number" value={dia.senhaFinal} onChange={(e) => handleDiaChange(index, "senhaFinal", e.target.value)} placeholder="Ex: 50" />

                  {/* ✅ NOVO: Preço do Boi TV específico para este dia */}
                  <label style={{ color: "#ffcc00", marginTop: "8px", display: "block" }}>
                    🎯 Boi TV neste dia (deixe em branco para usar o valor padrão):
                  </label>
                  <input
                    type="number"
                    value={dia.boiTvValor}
                    onChange={(e) => handleDiaChange(index, "boiTvValor", e.target.value)}
                    placeholder="Ex: 0 = Grátis | 25 = R$ 25,00 | vazio = padrão"
                  />
                </div>
              ))}

              <div className="modal-buttons">
                <button onClick={adicionarCategoria}><FaSave /> Salvar Categoria</button>
                <button onClick={fecharModal}><FaTimes /> Fechar</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default EditarEvento